import { motion } from "framer-motion";
import {
  Zap,
  Wrench,
  Flame,
  Wind,
  HardHat,
  Hammer,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    id: "electrical",
    icon: Zap,
    title: "Electrical Services",
    desc: "Full installations, fault finding, rewiring, EICR reports and lighting upgrades by certified electricians.",
  },
  {
    id: "plumbing",
    icon: Wrench,
    title: "Plumbing Services",
    desc: "Leaks, blockages, bathroom installs, pipework and emergency callouts — fixed first time.",
  },
  {
    id: "gas",
    icon: Flame,
    title: "Gas Services",
    desc: "Gas-Safe registered boiler servicing, repairs, installations and landlord safety certificates.",
  },
  {
    id: "hvac",
    icon: Wind,
    title: "Air Conditioning",
    desc: "Supply, install, service and repair of AC and climate systems for homes, offices and retail.",
  },
  {
    id: "maintenance",
    icon: HardHat,
    title: "Property Maintenance",
    desc: "Reactive and planned maintenance for landlords, agents and commercial property managers.",
  },
  {
    id: "repairs",
    icon: Hammer,
    title: "Repairs & Installations",
    desc: "Carpentry, fittings, fixings, finishes — small jobs to full refurbishments completed cleanly.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#F8FAFC] py-20 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-14">
          <div className="lg:col-span-7">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#64748B]">
              What we do
            </span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold text-[#0A192F] tracking-tight">
              Every trade. One reliable team.
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#334155] leading-relaxed">
            From a single repair to ongoing maintenance contracts, our
            qualified engineers cover the full range of building services your
            property needs — without the runaround of multiple contractors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((s, idx) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.45, delay: idx * 0.06 }}
                className="group relative bg-white border border-slate-200 rounded-md p-8 md:p-10 transition-all duration-300 hover:border-[#0A192F] hover:-translate-y-1 hover:shadow-xl"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-md bg-[#0A192F] text-white">
                    <Icon className="w-6 h-6" strokeWidth={1.6} />
                  </div>
                  <ArrowUpRight
                    className="w-5 h-5 text-slate-300 group-hover:text-[#0A192F] transition-colors"
                    strokeWidth={1.6}
                  />
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#0A192F]">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#334155] leading-relaxed text-sm">
                  {s.desc}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
